<template>
    <div>
        <!-- banner -->
        <div class="about-banner">
            <img src="../../assets/images/banner1.png" alt="">
                <!-- <div class="about_warp">
                <div class="top-text">
                    <p>关于我们</p>
                    <p> 能够简洁明了公司地址及其他信息</p>
                </div>
                <img src="" alt="">
            </div> -->
        </div>

        
        <div class="about">
            <!-- 面包屑 -->
            <!-- <Breadcrumb separator=">" class="nav_rot">
                <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
                <Breadcrumb-item>关于我们</Breadcrumb-item>
            </Breadcrumb> -->

            <!-- 关于我们内容 -->
            <div class="about-main">
                <!-- 左侧内容 -->
                <div class="left_about">
                    <p class="title_li">关于我们</p>
                    <ul>
                        <li id="tabs-list" class="active-list">公司介绍</li>
                        <li id="tabs-list">公司资质</li>
                        <li id="tabs-list">招贤纳士</li>
                        <li id="tabs-list">联系我们</li>
                    </ul>
                </div>

                <!-- 右侧内容 -->
                <div class="abt_cards">
                    <!-- 公司介绍 -->
                    <div id="about-list" class="abt-boss">
                        <p>公司简介</p>
                        <p>司马达拓（深圳）智能系统有限公司（以下简称司马大大） 成立于2012年12月， 是一家以人工智能为基础，致力于视频大数据智能化管理的高新技术企业。司马大大自主可控的BBW视频编码技术利用人工智能技术对视频数据进行压缩，减少数据冗余，压缩倍率最高可达20倍。自主研发的VDMS(Video Data Management System)产品在保证不影响原有分辨率，不改变视频帧率，不改变视频时长的基础上提供视频实时压缩，低码流无线传输和视频溯源服务，大大的减少了视频解决方案的成本。目前在安防、公安、交通、医疗、教育等大数据应用的前沿阵地具有广泛应用。</p>
                        <p>创始人:马兆远</p>
                        <div class="about_text">
                            <div style="height: 320px; float: left"><img src="../../assets/images/38.png" alt=""></div>
                            <p>马兆远博士，1997年保送北京大学技术物理系，2001年获得牛津大学Clarendon全额奖学金赴英国牛津大学攻读博士学位，导师为皇家学院院士、现任谢菲尔德大学校长Keith Burnett爵士。之后赴美国国家标准局作博士后研究，师从1997年诺贝尔奖获得者William Phillips。马兆远博士2009年入选中国科学院百人计划，2010年12月回国加入中科院上海光学精密机械研究所成为国家四级研究员、教授，2011年通过中科院百人计划择优支持。曾任国家973超冷原子操控及量子新物态研究项目课题负责人，中国空间站冷原子平台物理单元总设计师。2015年被深圳市信息化与工业化融合促进会聘为工业4.0专家顾问团首席专家。2016年马兆远博士经北京市海外学人工作联席会批准，入选“北京市海外高层次人才”（海聚工程），同时被聘为“北京市特聘专家”，同年出版专著《量子大唠嗑》。</p>
                        </div>
                    </div>

                    <!-- 公司资质 -->
                    <div id="about-list" class="certificate hide">
                        <p class="abt_cerP">公司资质</p>
                        <div class="abt_listimgone">                       
                            <div><img src="../../assets/images/23.png" alt=""><p>中关村高新技术企业证书</p></div>
                            <div><img src="../../assets/images/24.png" alt=""><p>高新技术企业证书</p></div>
                            <div class="three_img"><img src="../../assets/images/129.jpg" alt=""><p>视频智能处理器新技术新产品证书</p></div>
                            <div class="abt_listimgone">  
                                <div><img src="../../assets/images/130.jpg" alt="" style="margin-right: 20px;"><p>视频溯源防泄漏系统新技术新产品证书</p></div>
                                <div><img src="../../assets/images/131.jpg" alt=""><p>视频数据管理新技术新产品证书</p></div>
                            </div>
                        </div>

                        <p class="abt_cerP" style="margin-top: 70px;">产品认证</p>
                        <div class="abt_listimg">                       
                            <div><img src="../../assets/images/132.jpg" alt=""><p>司马大大9001质量管理体系认证证书</p></div>
                            <div><img src="../../assets/images/133.jpg" alt=""><p>视频数据管理系统检验报告</p></div>
                            <div class="three_img"><img src="../../assets/images/134.jpg" alt=""><p>中国国家强制性产品认证证书</p></div>
                        </div>

                        <p class="abt_cerP" style="margin-top: 70px;">公司专利</p>
                        <div class="abt_listimg" style="padding-bottom: 30px;">                       
                            <div><img src="../../assets/images/135.png" alt=""><p>《多运动目标捕捉与跟踪设备》专利证书</p></div>
                            <div><img src="../../assets/images/136.png" alt=""><p>《运动目标捕捉与跟踪设备》专利证书</p></div>
                            <div class="three_img"><img src="../../assets/images/137.png" alt="" style=""><p>《一种点读笔及点读系统》专利证书</p></div>
                            <div><img src="../../assets/images/138.png" alt=""><p>《VR摄像机及VR系统》专利证书</p></div>
                        </div>
                    </div>

                    <!-- 招纳贤士 -->
                    <div id="about-list"  class="recruit hide">
                        <span>职位名称</span>
                        <div class="rec_right">
                            <span>招聘人数</span>
                            <span>职位类别</span>
                            <span>工作地点</span>
                        </div>
                            <Collapse active-key="1">
                                <Panel key="1" active-key="1">
                                    深度学习/图像算法工程师
                                        <div class="rec_colright">
                                            <span>若干</span>
                                            <span>研发</span>
                                            <span>北京</span>
                                        </div>
                                    <div slot="content" class="rec_content">
                                        <p class="rec_titleP">岗位职责：</p>
                                            1. 负责图像/视频处理、深度学习相关算法的研发和实现；<br>
                                            2. 参与系统的需求调研和需求分析，撰写相关技术文档；<br>
                                            3.与软件工程师配合进行算法的跨平台开发和性能优化。<br>
                                        <p class="rec_titleP">任职要求：</p>
                                            1. 本科及以上学历，熟练掌握计算机视觉和深度学习基础理论和方法；<br>
                                            2. 熟练使用opencv，熟悉caffe、tensorflow、torch等框架中的一种或几种；<br>
                                            3. 熟练掌握C++/python编程，有良好的编程习惯；<br>
                                            4. 在目标检测、识别、跟踪等领域有深入研究者优先考虑；<br>
                                            5. 有faster R-CNN，YOLO等等深度学习的目标检测算法开发经验者优先。<br>
                                    </div>
                                </Panel>
                                <Panel key="2">
                                    C++软件开发工程师
                                    <div class="rec_colright">
                                            <span>若干</span>
                                            <span>研发</span>
                                            <span>北京</span>
                                    </div>
                                    <div slot="content" class="rec_content">
                                        <p class="rec_titleP">岗位职责：</p>
                                            1. 负责公司视频管理平台与其他平台对接的二次开发工作 <br>
                                            2. 基于FFMPEG的视频播放器的优化 <br>
                                            3. 流媒体服务的客户端开发 <br>
                                            4. 基于Qt的软件界面的开发 <br>
                                            5. 负责相关业务的客户端应用程序开发 <br>
                                            6. 基于QtAV进行音视频播放器的开发 <br>
                                            7. 负责相关文档的编写 <br>
                                            
                                        <p class="rec_titleP">任职要求：</p>
                                            1. 计算机相关专业，本科及以上学历 <br>
                                            2. C/C++基本功扎实，熟悉STL/Qt <br>
                                            3. 熟练使用VS或者VC++,Qt任何一套开发工具（有Qt开发经验者优先） <br>
                                            4. 熟悉网络编程和多线程编程 <br>
                                            5. 熟悉MySql等主流数据库 <br>
                                            6. 熟悉TCP/IP.UDP等基本网络协议 <br>
                                            7. 熟练使用linux系统 <br>
                                            8. 有良好的数据结构和算法基础，具备优秀的编码和调试能力 <br>
                                            9. 有FFMPEG/live555/Onvif使用经验者优先 <br>
                                            10. 有基于海康等视频监控厂家SDK二次开发经验者优先 <br>
                                    </div>
                                </Panel>
                                <Panel key="3">
                                    GPU图像算法工程师
                                    <div class="rec_colright">
                                            <span>若干</span>
                                            <span>研发</span>
                                            <span>北京</span>
                                    </div>
                                    <div slot="content" class="rec_content">
                                        <p class="rec_titleP">岗位职责：</p>
                                            1. 学习图像处理算法并评估其在GPU上实现的必要性及可行性。 <br>
                                            2. 使用CUDA开发图像处理算法的GPU实现并进行性能优化。 <br>
                                            3. 搭建GPU深度学习平台，优化深度学习算法性能。<br>
                                            
                                        <p class="rec_titleP">任职要求：</p>
                                            1. 本科以上学历，计算机相关专业，有1年以上GPU开发工作经验。<br>
                                            2. 熟练掌握C/C++，熟悉多线程编程，熟悉linux系统。<br>
                                            3. 熟练掌握GPU架构和CUDA原理，如线程管理机制和内存管理机制。<br>
                                            4. 熟悉CUDA driver API。<br>
                                            5. 熟悉CUDA工具集，包括CUDA C, nvvp，nvprof等。<br>
                                            6. 了解机器学习算法，了解TensorFlow/MXNet/CNTK/Caffe/Theano/Torch等深度学习框架。<br>
                                            7. 良好的沟通能力、团队合作精神与敬业精神。 <br>

                                         <p class="rec_titleP">具有以下条件者优先：</p>
                                            1. 熟悉图像处理算法和OpenCV。<br>
                                            2. 熟悉OpenCL。<br>
                                            3. 基于ARM系统的GPU开发经验。<br>
                                    </div>

                                </Panel>
                                <Panel key="4">
                                    产品研发经理
                                    <div class="rec_colright">
                                            <span>若干</span>
                                            <span>研发</span>
                                            <span>北京</span>
                                    </div>
                                    <div slot="content" class="rec_content">
                                        <p class="rec_titleP">技能要求：</p>
                                           <span>项目管理</span>
                                           <span>决策能力</span> 
                                           <span>产品设计</span>
                                            
                                        <p class="rec_titleP">岗位职责：</p>
                                            1、 作为产品线负责人，负责推广产品线发展，根据公司战略，制定产品的方向、技术标准、实施方案，<br>
                                            2、收集视频监控存储相关需求，对产品从业务调研、需求分析到实现过程、产品发布的整个流程进行管理和指导；<br>
                                            3、 负责撰写详细的产品需求文档及原型设计文档，管理产品研发进度；<br>
                                            4、负责视频监控类产品线研发版本规划；产品竞争力规划；研发预算规划；<br>
                                            5、参与开发；作为项目组Leader，对项目的范围/计划/风险/成本/资源等要素进行管理，确保项目如期完成；<br>

                                         <p class="rec_titleP">任职要求：</p>
                                            1. 本科及以上学历， 理工科优先；<br>
                                            2. 3年以上产品研发管理经验；<br>
                                            3. 有过视频监控平台类或存储类系统的规划设计、开发和项目管理经验；<br>
                                            4. 监控行业5年以上工作经验。<br>
                                    </div>

                                </Panel>
                                <Panel key="5">
                                    售前工程师
                                    <div class="rec_colright">
                                            <span>若干</span>
                                            <span>研发</span>
                                            <span>北京</span>
                                    </div>
                                    <div slot="content" class="rec_content">
                                        <p class="rec_titleP">岗位职责：</p>
                                            1、负责视频人工智能方向的售前技术支持、投标过程技术支撑；<br>
                                            2、负责项目跟进过程中技术文档的撰写和提供，包括公司资料、产品PPT、技术建议方案等；<br>
                                            3、配合销售人员与客户技术交流，演示等；<br>
                                            4、负责编写产品PPT，宣传册以及产品方案。<br>

                                        <p class="rec_titleP">任职要求：</p>
                                            1. 统招本科以上学历；<br>
                                            2.三年以上视频监控行业的售前支持经验；<br>
                                            3.熟悉安防业务应用功能，行业背景及趋势；<br>
                                            4.具有丰富的售前方案编写能力及讲解能力，能独立完成解决方案等专业文档的编写，具有一定的亲和力和感染力；<br>
                                            5.熟练掌握Axure软件优先；<br>
                                            6.熟练掌握ps/visio/ppt等工具。<br>

                                    </div>

                                </Panel>
                            </Collapse>
                    </div>

                    <!-- 联系我们 -->
                    <div id="about-list" class="call_we hide">
                        <!-- 地图 -->
                        <div class="abt_map">
                            <b-map-component style="height: 100%;"></b-map-component>
                        </div>
                        <p>地址：北京市海淀区北三环中路44号院C-308</p>
                        <p>邮箱：sales@bmi-tech.cn</p>
                        <p>电话：010-56254029</p>
                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
import $ from "../../../node_modules/jquery/dist/jquery.js";

import BMapComponent from '../BMapComponent/BMapComponent';
import header from "../cuscom/header";
export default {

    mounted:function(){
         $(".left_about #tabs-list").click(function () {
                $(".abt_cards #about-list").eq($(this).index()).removeClass("hide").siblings().addClass("hide");
                $('.left_about #tabs-list:nth-child(1)').removeClass("active-list");
                $(".left_about #tabs-list").eq($(this).index()).addClass("active-list").siblings().removeClass("active-list");
            });
        },
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
     components: {
            BMapComponent
        }

}
</script>

<style>
/* 版心 */
.about {
    width: 1200px;
    margin: 0 auto;
}
    /* banner图 */
 .about-banner {
     width: 100%;
     /* height: 681px; */
 }
 .about-banner img {
     width: 100%;
     height: 100%;
 }

/* 面包屑 */
.nav_rot {
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}

/* 关于我们内容 */
 .about-main {
     width: 1200px;
     overflow:hidden;
     margin: 0 auto;
     background: #ffffff;
     margin-top: 42px;
     margin-bottom: 65px;
 }

 /* 关于我们左侧内容 */
.left_about {
    width: 222px;
    float: left;
}

.left_about li {
    list-style: none;
    font-size: 18px;
    color: #333333;
    height: 50px;
    border-bottom: solid #dddddd 1px;
    line-height: 50px;
    padding-left: 23px;
    cursor: pointer;
    margin-top: 0px;
}
 .left_about li:nth-child(1) {
    border-top: 1px solid #dddddd;
 }
.left_about .title_li {
    font-size: 24px;
    padding: 0;
    margin-bottom: 10px;
}


.left_about .active-list {
    color: #29b3de;
}


/* 默认样式修改 */
.abt_updown .ivu-icon {
    display: none;
}
.abt_updown .ivu-collapse-content>.ivu-collapse-content-box {
    margin: 0px;
    padding: 0px;
}

/* 右侧内容 */
.abt_cards {
    width: 957px;
    background: #F2F2F2;
    word-break:break-all;
    padding-bottom:2000px;
    margin-bottom:-2000px;
    float: right;
    padding-left: 20px;
    padding-right: 15px;
    border: 1px solid #dddddd;
}

.hide {
    display: none;
}

.abt-boss p:nth-child(1) {
    font-size: 24px;
    color: #333333;
    margin-top: 16px;
    margin-bottom: 30px;  
}

.abt-boss p:nth-child(2) {
    font-size: 18px;
    color: #666666;
    line-height: 2;
    margin-bottom: 35px;  
}
.abt-boss p:nth-child(3) {
    font-size: 24px;
    color: #333333;
    margin-bottom: 29px;  
}

.about_text img {
    margin-right: 15px;
    float: left;
}
.about_text p {
    font-size: 22px;
    color: #333333;
}


/* 公司资质 */
.certificate .abt_cerP{
    font-size: 28px;
    color: #333333;
    width: 125px;
    margin: 50px auto;
}
/* 上方图片 */
.abt_listimgone {
    display: flex;
    justify-content: space-between;
    flex-wrap:  wrap;
}
.abt_listimgone img {
    width: 292px;
    height: 199px;
    margin-bottom: 8px;
    transition: all .1s ease-in-out;
}
.abt_listimgone img:hover {
    cursor: pointer;
    box-shadow: #646464 0 0 13px;
}
.abt_listimgone img:active {
    transform: scale(2);
}
/* 第三张图片 */
.abt_listimgone .three_img img:active {
    /* transform: scale(1.8); */
    transform:translateX(-140px)scale(2);
}

.abt_listimgone p {
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin-bottom: 38px;
}
/* 下方图片 */
.abt_listimg{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.abt_listimg img {
    width: 294px;
    height: 405px;
    margin-bottom: 10px;
    transition: all .1s ease-in-out;
}
.abt_listimg img:hover {
    box-shadow: #646464 0 0 13px;
}
.abt_listimg img:active {
    transform: scale(1.8);
}
/* 第三张图片 */
.abt_listimg .three_img img:active {
    /* transform: scale(1.8); */
    transform:translateX(-120px)scale(1.8);
}
.abt_listimg p {
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin-bottom: 38px;
}

/* 联系我们 */
.call_we {
    width: 825px;
    margin: 0 auto;
    padding-bottom: 120px;
}
.call_we p {
    font-size: 18px;
    color: #333333;
    margin-top: 5px;
}
/* 地图 */
.abt_map {
    width: 100%;
    height: 422px;
    margin-top: 40px;
    margin-bottom: 37px;
}
/* 招纳贤士 */
.recruit {
    padding-top: 30px;
}
.recruit span{
    color: #4088c8;
    font-size: 20px;
}
.rec_right {
    float: right;
}
.rec_right span {
    margin-left: 63px;
}

/* 下方折叠面板 */
.recruit .ivu-collapse {
    margin-top: 20px;
    background: #F2F2F2;
    border: none;
    font-size: 20px;
    color: #333333;
    padding-bottom: 50px;
}
.recruit  .ivu-icon  {
    display: none;
}

.recruit  .ivu-collapse-item:hover{
    /* border: none; */
    /* margin-left: -15px; */
    background: #F2F0F0;
}
.ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
    color: #333333;
}

.recruit .ivu-collapse-content>.ivu-collapse-content-box {
    margin-top: 0;
    padding-top: 0;
}
.rec_colright span {
    color: #333333;
    display: block;
    width: 60px;
    font-size: 20px;
    margin-left: 90px;
    float: left;
}
.recruit .rec_colright {
    float: right;
}
.rec_content {
    color: #333333;
    font-size: 16px;
}
.rec_content .rec_titleP {
    color: #333333;
    font-size: 18px;
    margin-bottom: 10px;
    padding-top: 15px;
}
.rec_content span {
    color: #333333;
    font-size: 18px;
    margin-right: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/about/about.vue